import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { useApplicationContext } from '~/shared/context/use-application-context';
import type { SkillReferences } from '~/shared/data-contract/skill';

import { useApplicationFetchers } from '../../../fetchers/use-application-fetchers';

export const skillReferencesKey = (skillId: string, language: string) =>
    ['skill-references', skillId, language] as const;

export const useSkillReferencesQuery = (skillId: string, language?: string): UseQueryResult<SkillReferences, Error> => {
    const { fetchSkillReferences } = useApplicationFetchers();
    const { applicationState } = useApplicationContext();
    const languageToUse = language ?? applicationState.language.code;

    return useQuery({
        queryFn: async () => {
            const result = await fetchSkillReferences({ language: languageToUse, skillId });

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: skillReferencesKey(skillId, languageToUse),
        throwOnError: false,
    });
};
